module.exports = __webpack_public_path__ + "static/ebr-12-af27d686184f44ad77a6f6a7f0d15874.jpg";